import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PrivateRoute } from "./services/PrivateRoute";

import { LotterySessions } from "./views/LotterySessions/LotterySessions";
import LotteryForm from "./views/LotterySessions/LotteryForm";

import NotFound from "./views/Layout/NotFound";
import { BaseLayout } from "./views/Layout/BaseLayout";

import { PrizeContainer } from "./views/Prizes/PrizeContainer";
import { PrizesContainer } from "./views/Prizes/PrizesContainer";
import { HomeContainer } from "./views/Home/HomeContainer";
import Snowfall from "./Components/Snowfall";
import { RunLotteryContainer } from "./views/RunLottery/RunLotteryContainer";
import { Login } from "./views/Login/Login";

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Snowfall />
      <Routes>
        <Route path="/" element={<BaseLayout />}>
          <Route index element={<HomeContainer />} />
          <Route
            path="lotteries"
            element={<PrivateRoute component={LotterySessions} />}
          />
          <Route
            path="lotteries/new"
            element={<PrivateRoute component={LotteryForm} />}
          />
          <Route
            path="lotteries/:id/edit"
            element={<PrivateRoute component={LotteryForm} />}
          />
          <Route
            path="prizes/:prizeId"
            element={<PrivateRoute component={PrizeContainer} />}
          />
          <Route
            path="prizes"
            element={<PrivateRoute component={PrizesContainer} />}
          />
          <Route
            path="run"
            element={<PrivateRoute component={RunLotteryContainer} />}
          />
        </Route>
        <Route path="login" element={<Login />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
